module.exports = __webpack_public_path__ + "Roboto-Light-webfont.a990f611f2305dc12965.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/gfurtado/Projects/v2.3 (ng4 2.1 only)/Angular 4 CLI/app/src/assets/fonts/roboto/Roboto-Light-webfont.eot
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Light-webfont.eot
// module chunks = styles